import React from 'react'

const RawHtmlContainer = ({ containerObject, templateName, contentId, dataZone }) => {
  return (
    <div>
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row g-0 col-12`} >
        <div dangerouslySetInnerHTML={{__html: containerObject.attributes.htmlRawContent}}></div> 
        </div>
    </div>
  )
}

export default RawHtmlContainer